<nz-breadcrumb class="ui-breadcrumb" nzSeparator="›">
  @for (item of items(); track $index; let last = $last) {
    <nz-breadcrumb-item>
      @if (item.icon) {
        <span nz-icon [nzType]="item.icon"></span>
      }
      @if (!last && item.url) {
        <a [routerLink]="item.url" [queryParams]="item.queryParams ?? null">{{ item.label }}</a>
      } @else {
        <span [class.ui-breadcrumb__current]="last">{{ item.label }}</span>
      }
    </nz-breadcrumb-item>
  }
</nz-breadcrumb>
